import React from 'react';

import { Grid } from '@mui/material';

import ChatAppBody from './layout/ChatAppBody';
import StyledHeader from 'app/components/shared/StyledHeader';
import ChatPrimary from './ChatPrimary';
import ChatSecondary from './ChatSecondary';

const ChatApp = () => {
  return (
    <ChatAppBody className="CHAT-APP">
      <StyledHeader
        data-test-id="template-shell-header"
        sx={{ paddingLeft: '1em' }}
      >
        Chat
      </StyledHeader>
      <Grid container sx={{ overflow: 'hidden' }}>
        {/* contacts list */}
        <Grid item sm={4} xs={12}>
          <ChatSecondary />
        </Grid>

        {/* messages */}
        <Grid item sm={8} xs={12}>
          <ChatPrimary />
        </Grid>
      </Grid>
    </ChatAppBody>
  );
};

export default ChatApp;
